'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _jsxFileName = 'src/new-business/stage4/components/choose-cover-radio.js';
var _arrayToIso = require('@marmalade/date/lib/array-to-iso');
var _arrayToIso2 = _interopRequireDefault(_arrayToIso);
var _radio = require('@marmalade/form/lib/components/radio');
var _radioButton = require('@marmalade/form/lib/components/radio/items/radio-button');
var _radioButton2 = _interopRequireDefault(_radioButton);
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
var _selectors = require('@marmalade/ldi/lib/quote/selectors');
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _selectors2 = require('@marmalade/query/lib/selectors');
var _themes = require('@marmalade/themes');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _sagePay = require('../../../../media/sage-pay.jpg');
var _sagePay2 = _interopRequireDefault(_sagePay);
var _propTypes2 = require('../../../prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var quotesContainerStyles = function quotesContainerStyles(_ref) {
  var theme = _ref.theme;
  return {
    margin: '-' + theme.space_sm,
    marginBottom: 'unset'
  };
};
var wrapperStyles = function wrapperStyles(_ref2) {
  var _ref3;
  var theme = _ref2.theme;
  return _ref3 = {
    textAlign: 'center',
    '& label': {
      width: '100%'
    }
  }, _defineProperty(_ref3, (0, _themes.atLeast)(theme.breakpoint_sm), {
    display: 'inline-block',
    width: '50%',
    '& label': {
      width: '80%'
    }
  }), _defineProperty(_ref3, 'padding', theme.space_sm), _ref3;
};
var panelStyles = function panelStyles(_ref4) {
  var theme = _ref4.theme,
    selected = _ref4.selected;
  return {
    backgroundColor: theme.colorWhite,
    borderColor: selected ? theme.colorSelected : theme.colorGreyLight,
    borderWidth: '1px',
    borderStyle: 'solid',
    padding: theme.space_sm
  };
};
var periodStyles = function periodStyles(_ref5) {
  var theme = _ref5.theme;
  return {
    fontWeight: theme.fontBold
  };
};
var priceStyles = function priceStyles(_ref6) {
  var theme = _ref6.theme;
  return {
    marginBottom: theme.space_xs,
    fontSize: '28px'
  };
};
var dailyPriceStyles = function dailyPriceStyles(_ref7) {
  var theme = _ref7.theme;
  return {
    marginBottom: theme.space_xs,
    color: theme.colorDarkGrey,
    fontWeight: theme.fontBold,
    display: 'block'
  };
};
var QuotesContainer = (0, _glamorous2.default)('div')(quotesContainerStyles);
var Wrapper = (0, _glamorous2.default)('div')(wrapperStyles);
var Panel = (0, _glamorous2.default)('div')(panelStyles);
var Period = (0, _glamorous2.default)('div')(periodStyles);
var Price = (0, _glamorous2.default)('div')(priceStyles);
var DailyPrice = (0, _glamorous2.default)('small')(dailyPriceStyles);
ChooseCoverLabel.propTypes = {
  updating: _propTypes.bool.isRequired,
  newStartDate: _propTypes.bool.isRequired,
  days: _propTypes.number.isRequired,
  quote: _propTypes2.quoteModel,
  children: _propTypes.node.isRequired,
  selected: _propTypes.bool
};
ChooseCoverLabel.defaultProps = {
  quote: undefined,
  selected: false
};
function ChooseCoverLabel(props) {
  return _react2.default.createElement(Wrapper, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83
    },
    __self: this
  }, _react2.default.createElement(Panel, {
    selected: props.selected,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84
    },
    __self: this
  }, _react2.default.createElement(Period, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85
    },
    __self: this
  }, props.days, ' days'), _react2.default.createElement(Price, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86
    },
    __self: this
  }, '\xA3', props.updating ? _react2.default.createElement(_loading2.default, {
    inline: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87
    },
    __self: this
  }) : props.newStartDate ? 'unavailable' : props.quote.premium, '*'), _react2.default.createElement(DailyPrice, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89
    },
    __self: this
  }, 'That\'s just \xA3', props.quote.daily, ' per day!'), props.children));
}
var ConnectedChooseCoverLabel = (0, _reactRedux.connect)(function (state) {
  return {
    newStartDate: (0, _selectors.getQuoteOptions)(state).coverStartDate !== (0, _arrayToIso2.default)((0, _fieldInfo.getValue)(state, 'newBusinessStage4', 'coverStartDate'))
  };
})(ChooseCoverLabel);
var ChooseCoverRadio = function (_Component) {
  _inherits(ChooseCoverRadio, _Component);
  function ChooseCoverRadio() {
    var _ref8,
      _this2 = this;
    var _temp, _this, _ret;
    _classCallCheck(this, ChooseCoverRadio);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref8 = ChooseCoverRadio.__proto__ || Object.getPrototypeOf(ChooseCoverRadio)).call.apply(_ref8, [this].concat(args))), _this), _this.renderOptions = function (selected, onChange) {
      return _react2.default.createElement(QuotesContainer, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        },
        __self: _this2
      }, _this.props.options.map(function (option) {
        var isSelected = selected === option.cover.toString();
        return _react2.default.createElement(ConnectedChooseCoverLabel, {
          days: option.cover,
          quote: option.premium,
          key: option.cover,
          updating: _this.props.updating,
          selected: isSelected,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 120
          },
          __self: _this2
        }, _react2.default.createElement(_radioButton2.default, {
          name: _this.props.name,
          text: 'Select' + (isSelected ? 'ed' : ''),
          value: option.cover.toString(),
          onChange: onChange,
          selected: isSelected,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 127
          },
          __self: _this2
        }));
      }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(ChooseCoverRadio, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_radio.RadioWrapper, {
        name: this.props.name,
        defaultValue: this.props.qqCover,
        extra: _react2.default.createElement('img', {
          src: _sagePay2.default,
          alt: 'Secured by Sage Pay logo with Visa, Mastercard and Paypal logos',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 146
          },
          __self: this
        }),
        render: this.renderOptions,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 143
        },
        __self: this
      });
    }
  }]);
  return ChooseCoverRadio;
}(_react.Component);
ChooseCoverRadio.propTypes = {
  options: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,
  name: _propTypes.string.isRequired,
  updating: _propTypes.bool.isRequired,
  qqCover: _propTypes.string
};
ChooseCoverRadio.defaultProps = {
  qqCover: undefined
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    qqCover: (0, _selectors2.getQuery)(state, 'cover')
  };
})(ChooseCoverRadio);